import { LAYOUT_MODE_TYPES, LAYOUT_POSITION_TYPES, LAYOUT_SIDEBAR_TYPES, LAYOUT_TOPBAR_THEME_TYPES, LAYOUT_TYPES, LAYOUT_WIDTH_TYPES, LEFT_SIDEBAR_IMAGE_TYPES, LEFT_SIDEBAR_SIZE_TYPES, LEFT_SIDEBAR_VIEW_TYPES, PERLOADER_TYPES, SIDEBAR_VISIBILITY_TYPES } from 'Components/constants/layout';
import { LayoutActionTypes, LayoutState, LayoutActions } from './types';
import { Reducer } from "redux";


// 1️⃣ Add this helper to get persisted state from localStorage
const getInitialState = (): LayoutState => {
  const saved = localStorage.getItem("themeSettings");
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      return {
        layoutType: parsed.layoutType || LAYOUT_TYPES.HORIZONTAL,
        layoutModeType: parsed.layoutModeType || LAYOUT_MODE_TYPES.LIGHTMODE,
        leftSidebarType: parsed.leftSidebarType || LAYOUT_SIDEBAR_TYPES.LIGHT,
        layoutWidthType: parsed.layoutWidthType || LAYOUT_WIDTH_TYPES.FLUID,
        layoutPositionType: parsed.layoutPositionType || LAYOUT_POSITION_TYPES.FIXED,
        topbarThemeType: parsed.topbarThemeType || LAYOUT_TOPBAR_THEME_TYPES.DARK,
        leftsidbarSizeType: parsed.leftsidbarSizeType || LEFT_SIDEBAR_SIZE_TYPES.DEFAULT,
        leftSidebarViewType: parsed.leftSidebarViewType || LEFT_SIDEBAR_VIEW_TYPES.DEFAULT,
        leftSidebarImageType: parsed.leftSidebarImageType || LEFT_SIDEBAR_IMAGE_TYPES.NONE,
        preloader: parsed.preloader || PERLOADER_TYPES.DISABLE,
        sidebarVisibilitytype: parsed.sidebarVisibilitytype || SIDEBAR_VISIBILITY_TYPES.SHOW,
        themePrimary: parsed.themePrimary,
        themeSecondary: parsed.themeSecondary || '',
        light_logo: parsed?.light_logo,
        dark_logo: parsed?.dark_logo,
        light_logo_sm: parsed?.light_logo_sm,
        dark_logo_sm: parsed?.dark_logo_sm
      };
    } catch (err) {
      console.warn("Invalid themeSettings in localStorage", err);
    }
  }

  return {
    layoutType: LAYOUT_TYPES.HORIZONTAL,
    layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE,
    leftSidebarType: LAYOUT_SIDEBAR_TYPES.LIGHT,
    layoutWidthType: LAYOUT_WIDTH_TYPES.FLUID,
    layoutPositionType: LAYOUT_POSITION_TYPES.FIXED,
    topbarThemeType: LAYOUT_TOPBAR_THEME_TYPES.DARK,
    leftsidbarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT,
    leftSidebarViewType: LEFT_SIDEBAR_VIEW_TYPES.DEFAULT,
    leftSidebarImageType: LEFT_SIDEBAR_IMAGE_TYPES.NONE,
    preloader: PERLOADER_TYPES.DISABLE,
    sidebarVisibilitytype: SIDEBAR_VISIBILITY_TYPES.SHOW,
    themePrimary: "",
    themeSecondary: '',
    light_logo: '',
    dark_logo: '',
    light_logo_sm: '',
    dark_logo_sm: ''
  };
};

// 2️⃣ Replace static state with dynamic one
const initialState: LayoutState = getInitialState();


const persistToLocalStorage = (state: LayoutState) => {
  localStorage.setItem("themeSettings", JSON.stringify(state));
};


const reducer = (state = initialState, action: LayoutActions): LayoutState => {
  switch (action.type) {
    case LayoutActionTypes.CHANGE_LAYOUT:
      persistToLocalStorage({ ...state, layoutType: action.payload })
      return { ...state, layoutType: action.payload };
    case LayoutActionTypes.CHANGE_LAYOUT_MODE:
      persistToLocalStorage({ ...state, layoutModeType: action.payload })
      return { ...state, layoutModeType: action.payload };
    case LayoutActionTypes.CHANGE_SIDEBAR_THEME:
      persistToLocalStorage({ ...state, leftSidebarType: action.payload })
      return { ...state, leftSidebarType: action.payload };
    case LayoutActionTypes.CHANGE_LAYOUT_WIDTH:
      persistToLocalStorage({ ...state, layoutWidthType: action.payload })
      return { ...state, layoutWidthType: action.payload };
    case LayoutActionTypes.CHANGE_LAYOUT_POSITION:
      persistToLocalStorage({ ...state, layoutPositionType: action.payload })
      return { ...state, layoutPositionType: action.payload };
    case LayoutActionTypes.CHANGE_TOPBAR_THEME:
      persistToLocalStorage({ ...state, topbarThemeType: action.payload })
      return { ...state, topbarThemeType: action.payload };
    case LayoutActionTypes.CHANGE_LEFTSIDEBAR_SIZE:
      persistToLocalStorage({ ...state, leftsidbarSizeType: action.payload })
      return { ...state, leftsidbarSizeType: action.payload };
    case LayoutActionTypes.CHANGE_LEFTSIDEBAR_VIEW:
      persistToLocalStorage({ ...state, leftSidebarViewType: action.payload })
      return { ...state, leftSidebarViewType: action.payload };
    case LayoutActionTypes.CHANGE_SIDEBAR_IMAGE:
      persistToLocalStorage({ ...state, leftSidebarImageType: action.payload })
      return { ...state, leftSidebarImageType: action.payload };
    case LayoutActionTypes.CHANGE_PRELOADER:
      persistToLocalStorage({ ...state, preloader: action.payload })
      return { ...state, preloader: action.payload };
    case LayoutActionTypes.CHANGE_SIDEBAR_VISIBILITY:
      persistToLocalStorage({ ...state, sidebarVisibilitytype: action.payload })
      return { ...state, sidebarVisibilitytype: action.payload };
    case LayoutActionTypes.CHANGE_THEME_PRIMARY:
      persistToLocalStorage({ ...state, themePrimary: action.payload })
      return { ...state, themePrimary: action.payload };
    case LayoutActionTypes.CHANGE_THEME_SECONDARY:
      persistToLocalStorage({ ...state, themeSecondary: action.payload })
      return { ...state, themeSecondary: action.payload };
    case LayoutActionTypes.CHANGE_LIGHT_LOGO:
      const objvar = { ...state, light_logo: action.payload }
      persistToLocalStorage(objvar)
      return objvar;
    case LayoutActionTypes.CHANGE_DARK_LOGO:
      persistToLocalStorage({ ...state, dark_logo: action.payload })
      return { ...state, dark_logo: action.payload };

    case LayoutActionTypes.CHANGE_LIGHT_LOGO_SMALL:
      persistToLocalStorage({ ...state, light_logo_sm: action.payload })
      return { ...state, light_logo_sm: action.payload };
    case LayoutActionTypes.CHANGE_DARK_LOGO_SMALL:
      persistToLocalStorage({ ...state, dark_logo_sm: action.payload })
      return { ...state, dark_logo_sm: action.payload };
    case LayoutActionTypes.CHANGE_SETTHEME:
      let newTheme: any = action.payload;
      persistToLocalStorage(newTheme);
      return newTheme;
    case LayoutActionTypes.CHANGE_RESET:
      let newState =  {
        layoutType: LAYOUT_TYPES.HORIZONTAL,
        layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE,
        leftSidebarType: LAYOUT_SIDEBAR_TYPES.LIGHT,
        layoutWidthType: LAYOUT_WIDTH_TYPES.FLUID,
        layoutPositionType: LAYOUT_POSITION_TYPES.FIXED,
        topbarThemeType: LAYOUT_TOPBAR_THEME_TYPES.DARK,
        leftsidbarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT,
        leftSidebarViewType: LEFT_SIDEBAR_VIEW_TYPES.DEFAULT,
        leftSidebarImageType: LEFT_SIDEBAR_IMAGE_TYPES.NONE,
        preloader: PERLOADER_TYPES.DISABLE,
        sidebarVisibilitytype: SIDEBAR_VISIBILITY_TYPES.SHOW,
        themePrimary: "",
        themeSecondary: '',
        light_logo: '',
        dark_logo: '',
        light_logo_sm: '',
        dark_logo_sm: ''
      };
      persistToLocalStorage(newState);
      return newState;
    default:
      return state;
  }
};

export { reducer as layoutReducer };
